const header = {
  // all the properties are optional - can be left empty or deleted
  homepage: 'https://rosonkc.com.np',
  title: 'Portfolio',
}

const about = {
  // all the properties are optional - can be left empty or deleted
  name: 'Roshan Kc',
  role: 'Software Engineer | AI Automation Builder',
  description:
    'Software Engineer with 6+ years of experience building scalable, AI-powered, and cloud-native solutions. Worked with 20+ clients across SaaS, E-commerce, restaurants, tours, and local businesses. Specializing in AI & automation, cloud-native architectures, SaaS platforms, and full-stack development. Proven track record of scaling products to 10k+ users, reducing cloud costs by 40%, and building AI-powered systems processing 100K+ images in real-time.',

  resume: '/resume.pdf',
  social: {
    linkedin: 'https://www.linkedin.com/in/theroshankc',
    github: 'https://github.com/roshankcpkr',
    facebook: 'https://www.facebook.com/roshan.phtml',
    instagram: 'https://www.instagram.com/notroshankc',
    tweet: 'https://twitter.com/notroshankc',
  },
}

const projects = [
  // projects can be added an removed
  // if there are no projects, Projects section won't show up
  {
    name: 'Tourmoo - Travel Platform',
    description:
      'Complete SaaS solution for travel businesses. Built multitenant architecture, implemented SEO best practices, and managed cloud deployment. Scaled from concept to production serving multiple travel agencies.',
    stack: ['Next.js', 'Node.js', 'PostgreSQL', 'AWS', 'Stripe'],
    sourceCode: 'https://github.com/roshankcpkr',
    livePreview: 'https://tourmoo.com',
  },
  {
    name: 'Locomoo - Social App',
    description:
      'Location-based social app with live radar and viral features. Scaled to 40k+ active users within first year.',
    stack: ['React Native', 'Node.js', 'MongoDB', 'Redis', 'AWS'],
    sourceCode: 'https://github.com/roshankcpkr',
    livePreview: 'https://locomoo.app',
  },
  {
    name: 'PicBee - Event Photos',
    description:
      'AI-powered event photo platform with face recognition. Processes 100K+ images in real-time.',
    stack: ['Next.js', 'Python', 'TensorFlow', 'AWS Lambda'],
    sourceCode: 'https://github.com/roshankcpkr',
    livePreview: 'https://picbee.app',
  },
  {
    name: 'CellSight - TB Detector',
    description:
      'AI medical diagnostic tool for tuberculosis detection using IoT and machine learning.',
    stack: ['Flask', 'TensorFlow Lite', 'Raspberry Pi', 'ESP32'],
    sourceCode: 'https://github.com/roshankcpkr/tuberculosis-bacilli-detector',
  },
]

const certifications = [
  {
    name: 'AWS Certified CloudOps Engineer - Associate',
    description: 'AWS certification for cloud operations',
    livePreview: 'https://cp.certmetrics.com/amazon/en/public/verify/credential/4e5bc72a6f6042c580673578abedb4df',
  },
  {
    name: 'AWS Certified Data Engineer - Associate',
    description: 'AWS certification for data engineering',
    livePreview: 'https://cp.certmetrics.com/amazon/en/public/verify/credential/2ecac296fe5146d39bf4454ccf5da411',
  },
  {
    name: 'Oracle Cloud Infrastructure 2025 Certified DevOps Professional',
    description: 'Oracle certification for DevOps',
    livePreview: 'https://catalog-education.oracle.com/ords/certview/sharebadge?id=2A5A5B6C00D6EE26801457A397E76F0D226CB126C18FBD9D60593B50F67E0CC9',
  },
  {
    name: 'Oracle Cloud Infrastructure 2025 Certified Architect Associate',
    description: 'Oracle certification for cloud infrastructure architecture',
    livePreview: 'https://catalog-education.oracle.com/pls/certview/sharebadge?id=48DD614AE619ED1E6AF53973676F63AAAE612A17BE324ACB531702752AFEDAD8'
  },
  {
    name: 'AWS Certified Machine Learning Engineer - Associate',
    description: 'AWS certification for machine learning',
    livePreview: 'https://cp.certmetrics.com/amazon/en/public/verify/credential/c1e16b0e3307491da7c144ba9744c992',
  },
  {
    name: 'AWS Certified AI Practitioner',
    description: 'AWS certification for AI/ML services and solutions',
    livePreview: 'https://cp.certmetrics.com/amazon/en/public/verify/credential/8fab41436f3c4fbfa87916919630b3f6',
  },
  {
    name: 'Microsoft Azure Fundamentals',
    description: 'Microsoft certification for Azure cloud fundamentals',
    livePreview: 'https://learn.microsoft.com/en-us/users/roshankc-7318/credentials/f448f8798a5f049e',
  },
  {
    name: 'AWS Certified Cloud Practitioner',
    description: 'AWS certification for cloud operations and administration',
    livePreview: 'https://cp.certmetrics.com/amazon/en/public/verify/credential/eeb5422e581c40539ca85637a25e7ab0',
  },
  {
    name: 'AWS Certified Developer - Associate',
    description: 'AWS certification for developing cloud applications',
    livePreview: 'https://cp.certmetrics.com/amazon/en/public/verify/credential/25a0a5aef60845738f8c87a875e5d35f',
  },
  {
    name: 'AWS Certified Solutions Architect - Associate',
    description: 'AWS certification for solutions architecture',
    livePreview: 'https://cp.certmetrics.com/amazon/en/public/verify/credential/9f6b73f6a3c34ca8aed276be6e173fbc',
  },
]

const skills = [
  // skills can be added or removed
  // if there are no skills, Skills section won't show up
  'Cloud Administration',
  'Data Engineering',
  'Data Analysis',
  'AI & Machine Learning',
  'Python',
  'JavaScript/TypeScript',
  'Full Stack Development',
  'Mobile Development',
  'SaaS Architecture',
  'Microservices',
  'DevOps & CI/CD',
  'AWS/GCP/Azure',
  'Next.js & React',
  'Node.js & NestJS',
  'Django & Flask',
  'PostgreSQL & MongoDB',
  'Docker & Kubernetes',
  'SEO Optimization',
]

const contact = {
  // email is optional - if left empty Contact section won't show up
  email: 'roshankcpkr480@gmail.com',
  phone: '+9779864432137',
  address: 'Pokhara, Gandakī, Nepal',
}

const experience = [
  {
    role: 'Founder & Software Engineer',
    company: 'Tourmoo',
    duration: 'March 2025 - Present',
    location: 'Pokhara, Gandakī, Nepal',
    description: [
      'Technical founder developing complete SaaS platform for travel businesses',
      'Handling backend development and API integration with Next.js',
      'Implemented complete multitenant system architecture',
      'Applied SEO best practices for optimal search visibility',
      'Managed task assignments, deadlines, and team coordination',
      'Formed cloud deployment guidelines and strategies',
    ],
  },
  {
    role: 'Software Engineer | Founder',
    company: 'Bingo Labs Private Limited',
    duration: 'September 2024 - Present',
    location: 'Pokhara, Gandakī, Nepal',
    description: [
      'Managing multiple projects and coordinating deadlines',
      'Designing efficient and scalable software architecture',
      'Developing applications with modern tech stacks',
      'Managing cloud services and AI pipelines',
      'Leading development of Locomoo (40k+ users), PicBee, and other products',
    ],
  },
  {
    role: 'Software Engineer',
    company: 'Self-employed',
    duration: 'January 2018 - August 2024',
    location: 'Pokhara, Gandakī, Nepal',
    description: [
      'Worked with 50+ clients across SaaS, E-commerce, restaurants, and local businesses',
      'Built scalable, AI-powered, and cloud-native solutions',
      'Reduced cloud expenses by 40% through optimization',
      'Developed AI-powered systems processing 100K+ images in real-time',
      'Automated business processes using AI & cloud workflows, boosting efficiency by 3x',
    ],
  },
]

const education = [
  {
    degree: 'Bachelor in Computer Science and Information Technology',
    institution: 'Tribhuvan University - IOST',
    duration: '2021 - 2025',
    location: 'Nepal',
    description: 'Focused on Computer Science fundamentals, software engineering, and information technology',
  },
  {
    degree: 'Higher Secondary Education (+2) - Science',
    institution: 'Gandaki Boarding School',
    duration: '2018 - 2021',
    location: 'Nepal',
    description: 'Science stream with focus on Physics, Chemistry, Mathematics, and Computer Science',
  },
]

const volunteering = [
  {
    role: 'Microsoft Student Ambassador',
    organization: 'Microsoft',
    duration: 'Ongoing',
    location: 'Remote',
    description: [
      'Part of a global group of campus leaders helping fellow students',
      'Building robust tech communities and developing technical skills',
      'Creating opportunities for students to learn and grow in technology',
    ],
    certificateUrl: 'https://mvp.microsoft.com/studentambassadors/certificate/77caec98-3361-4da6-911f-33ca876530e7',
  },
  {
    role: 'Executive',
    organization: 'CSIT Association of Nepal-Pokhara',
    duration: 'September 2023 - September 2024',
    location: 'Pokhara, Nepal',
    description: [
      'Served as executive member of CSIT Association',
      'Organized tech events and workshops for students',
      'Built connections within the Computer Science community',
    ],
  },
  {
    role: 'Founder - Executive',
    organization: 'MacItHub',
    duration: 'April 2022 - September 2025',
    location: 'Pokhara, Nepal',
    description: [
      'Founded and led MacItHub technology community',
      'Organized various hands-on events and workshops',
      'Directly impacted more than 500 students through tech education',
    ],
  },
  {
    role: 'School Representative',
    organization: 'Nepal Red Cross Society',
    duration: 'April 2015 - April 2018',
    location: 'Nepal',
    description: [
      'Represented school in disaster and humanitarian relief activities',
      'Participated in community service and awareness programs',
      'Contributed to humanitarian initiatives',
    ],
  },
]

const blogs = [
  {
    title: 'Building a Cost-Efficient Event-Driven API Using AWS Lambda, API Gateway, and SQS',
    slug: 'building-a-cost-efficient-event-driven-api-using-aws-lambda-api-gateway-and-sqs',
    description: 'Learn how to design production-ready, event-driven APIs using AWS Lambda, API Gateway, and SQS that scale automatically, fail gracefully, and stay affordable.',
    publishedDate: '2025-10-18',
    readTime: '12 min read',
    content: `When people talk about serverless, they often focus on how "easy" it is or how it "auto-scales." In reality, serverless becomes valuable only when you design for failure, spikes, and cost control from the beginning.

### Introduction: Why Event-Driven Serverless Matters in the Real World

I started using AWS Lambda and API Gateway while building APIs that had unpredictable traffic patterns. Some days the system would receive only a few dozen requests. Other days, a single shared link would cause thousands of requests within minutes. Running EC2 instances for this kind of traffic never made financial sense, paying for idle capacity felt wasteful, yet under-provisioning meant poor user experience during spikes.

This article documents how I designed a production-ready, event-driven API using **AWS Lambda**, **API Gateway**, and **Amazon SQS**. This is not a tutorial copied from documentation. Every design choice here exists because something broke, became expensive, or became difficult to debug in a real system.

### The Core Problem: Synchronous APIs Don't Scale Gracefully

A traditional API architecture often looks like this:

\`\`\`
Client → API → Business Logic → Database → Response
\`\`\`

This tight coupling works fine until reality hits:

* One downstream service slows down, creating cascading delays
* Traffic spikes arrive unexpectedly, overwhelming your system
* Long-running tasks block request handlers, causing timeouts
* Failures force aggressive retries from clients, amplifying the problem

In my early implementations, I made the critical mistake of putting too much logic inside a single Lambda function triggered directly by API Gateway. It worked perfectly during development and light testing, but failed spectacularly under real-world load. Response times became unpredictable. Timeouts increased. Worst of all, costs became difficult to forecast.

The real solution wasn't adding more compute power or optimizing code. **It was decoupling**.

### High-Level Architecture Overview

The architecture I eventually settled on follows this flow:

1. Client sends an HTTP request to API Gateway
2. API Gateway triggers an "ingress" Lambda function
3. Ingress Lambda validates the request and publishes a message to SQS
4. Worker Lambda processes messages asynchronously from the queue
5. Failures are retried automatically by SQS
6. A Dead-Letter Queue captures messages that consistently fail

This architectural separation fundamentally changed how the system behaved under stress. Instead of cascading failures, each component could fail and recover independently.

### Why API Gateway HTTP API (Not REST API)

AWS offers multiple API Gateway flavors, and the choice matters more than you might think. I specifically chose **HTTP API** instead of REST API for several concrete reasons:

**Lower cost per request** : HTTP APIs cost significantly less than REST APIs for the same traffic volume. At scale, this difference becomes substantial.

**Faster cold starts** : HTTP APIs have less overhead, resulting in quicker Lambda invocations and better user experience.

**Simpler configuration** : Less complexity means fewer places for bugs to hide and faster iteration cycles.

**Native Lambda proxy integration** : The integration is cleaner and requires less transformation logic.

Unless you absolutely need advanced features like request transformation, API keys at massive scale, or AWS WAF integration, HTTP API is often the superior default choice.

### Designing the Ingress Lambda (The "Fast Exit" Principle)

The ingress Lambda has **one job only**:

\`\`\`
Accept request → Validate → Enqueue → Return response
\`\`\`

It explicitly does NOT:

* Talk to databases
* Call external APIs
* Perform complex computations
* Execute business logic

This Lambda returns **\`202 Accepted\`**, not \`200 OK\`.

**Why?** Because the request is *accepted*, not *completed*. This distinction is crucial for setting correct client expectations and improving system reliability.

This simple design decision dramatically improved both perceived performance and actual reliability. Users receive acknowledgment instantly, while heavy processing happens asynchronously in the background.

### Input Validation Strategy

My validation approach in the ingress Lambda is intentionally minimal:

**I validate:**
* Required fields are present
* Payload size is within limits
* Data types match expectations
* Request format is parseable

**I do NOT validate:**
* Business rules (those belong in the worker)
* Database constraints
* Complex authorization logic (handled upstream)
* External dependencies

The faster this Lambda exits, the cheaper and more scalable the entire system becomes. This function should complete in milliseconds, not seconds.

### Why SQS Is the Most Underrated AWS Service

Amazon SQS is boring, and that's exactly why it's powerful. It doesn't promise magical features. It just works, reliably, at massive scale.

**SQS provides:**

* Automatic retry logic out of the box
* Natural backpressure handling
* Near-infinite horizontal scaling
* Extremely low cost (pennies per million requests)

By placing SQS between request ingestion and processing, you gain incredible operational benefits:

* Traffic spikes are absorbed by the queue, not your workers
* Downstream failures don't impact user-facing endpoints
* You inherit retry semantics for free, eliminating complex error-handling code
* Processing rate decouples from request rate

### Visibility Timeout: A Critical Setting

One configuration mistake I see repeatedly is incorrect **visibility timeout** settings.

**Rule of thumb:**
\`\`\`
Visibility Timeout > Maximum Lambda Execution Time
\`\`\`

If your Lambda function can run for up to 30 seconds, your visibility timeout should be at least 60 seconds, ideally higher to account for variability.

**Why this matters:**

If visibility timeout is too short, messages become visible to other workers while still being processed. This causes:

* Duplicate processing of the same message
* Wasted compute resources
* Data inconsistencies
* Race conditions that are nightmare to debug

I learned this lesson the hard way when I noticed the same records being created multiple times in my database. Tracking down the root cause led me to this misconfiguration.

### Worker Lambda: Where Real Work Happens

The worker Lambda is where all the actual business logic lives. This function:

* Is triggered automatically by SQS messages
* Handles complex computations, database writes, external API calls
* Can fail safely without affecting users
* Scales automatically based on queue depth

**If this Lambda fails:**

* SQS automatically retries it based on your configuration
* No client sees the failure
* No manual intervention required
* The system self-heals

This is the beauty of event-driven architecture. Failures become expected, handled gracefully, and invisible to end users.

### Handling Failures Gracefully with Dead-Letter Queues

I always configure two critical settings:

1. **Maximum receives** (e.g., 5 attempts)
2. **Dead-Letter Queue (DLQ)** for poison messages

**Why?** Because some failures are not transient. They represent actual problems that won't resolve by retrying.

Instead of retrying failed messages indefinitely (wasting money and compute), my setup:

* Tries each message up to 5 times
* Moves consistently failing messages to a DLQ
* Allows me to inspect failures manually
* Enables me to fix the root cause
* Supports message replay after fixes

The DLQ becomes your debugging ally. It captures edge cases, data quality issues, and integration problems that you didn't anticipate during development.

### Cost Analysis: Why This Architecture Is Cheap

Let's compare the economics:

**EC2-based API architecture:**
* Idle compute cost (24/7 pricing even with no traffic)
* Load balancer costs (fixed monthly fee)
* Auto-scaling complexity and operational overhead
* Over-provisioning for peak capacity

**Serverless Event-Driven API:**
* Pay per request (no idle costs)
* Pay only for actual execution time
* SQS costs are negligible (fractions of a cent per million requests)
* Automatic scaling included

For low to medium workloads which describes most APIs, serverless wins decisively on cost. You're not paying for infrastructure when it's idle. You're paying only for value delivered.

### Observability: Logging That Actually Helps

Good logging is the difference between solving an incident in 10 minutes versus 10 hours.

**I use structured logging with:**

* Request IDs from API Gateway
* Message IDs from SQS
* Correlation IDs passed through the entire flow
* Timestamps in ISO format
* Structured JSON instead of free-form strings

This makes tracing a single request across multiple services possible, even without expensive distributed tracing tools. When something goes wrong, I can follow a single ID through CloudWatch Logs to see exactly what happened.

### Common Mistakes I Made (So You Don't Have To)

Let me save you some pain by sharing my failures:

1. **Putting too much logic in the API Lambda** : This destroys the benefits of async processing
2. **Forgetting Dead-Letter Queues** : Without DLQs, failures vanish into the void
3. **Passing huge payloads through SQS** : Messages have a 256 KB limit; store large data in S3 instead
4. **Ignoring visibility timeout** : Leads to duplicate processing nightmares
5. **Treating Lambda like EC2** : Serverless requires a different mental model

The biggest mindset shift: **Embrace failure as normal**. Design for it. Make it observable. Make it recoverable.

### When This Architecture Is NOT Suitable

I'm not claiming this is a universal solution. Avoid this pattern if:

* You need synchronous responses with computed results
* You require single-digit millisecond latency
* You process large binary data inline (video encoding, image processing)
* Your workload is consistently high (EC2 might be cheaper)

**Serverless is powerful, but not universal.** Use the right tool for the job.

### Final Thoughts

This architecture helped me build APIs that:

* Scale automatically from zero to thousands of requests per second
* Fail gracefully without cascading errors
* Stay affordable even during traffic spikes
* Are easy to reason about and debug

If you're building APIs under uncertainty, where traffic patterns are unpredictable, requirements evolve rapidly, or you need to move fast, event-driven serverless is not just an option. **It's often the best default.** The infrastructure manages itself. You focus on business logic. And your AWS bill stays predictable. That's the real promise of serverless, and with the right architecture, it actually delivers.`
  },
  {
    title: 'Orchestrating Real-World Serverless Workflows Using AWS Step Functions',
    slug: 'orchestrating-real-world-serverless-workflows-using-aws-step-functions',
    description: 'In this blog, we will discuss about real world serverless workflows using AWS Step Functions. If you are worried about over-engineering, then you have come to the right place.',
    publishedDate: '2025-08-09',
    readTime: '8 min read',
    content: `In this blog, we will discuss about real world serverless workflows using AWS Step Functions. If you are worried about over-engineering, then you have come to the right place. We are anti over engineering cult, obviously.

![](https://cdn.hashnode.com/res/hashnode/image/upload/v1768057449987/c078e822-4ab8-4b4a-a5f5-02589241dec7.png)

### All started when Lambdas started becoming a Problem

Lambda functions are easy to start with. The problem begins when your application grows, and logic spreads across multiple asynchronous steps.

At one point, my system had:

* One Lambda triggering another
* Manual retries inside code
* Logs scattered everywhere
* No single view of execution state

Debugging failures felt like detective work. I used to think using a single service was the solution to not doing overengineering, but that's where I was wrong. Keeping things simple have different point of view. That's when I started using **AWS Step Functions** seriously.

### What Step Functions Actually Solve

Step Functions are not just "Lambda orchestration."

![](https://cdn.hashnode.com/res/hashnode/image/upload/v1768057459459/1f7d406d-1eee-4ad6-ab24-a972b8486c2b.png)

They provide:

* Explicit state
* Visual execution
* Built-in retries
* Failure handling
* Clear separation of concerns

Instead of hiding workflow logic inside code, Step Functions **make it visible**.

### A Real Workflow Example

The workflow:

1. User uploads a file
2. Validate metadata
3. Process content
4. Store result
5. Notify user

This sounds simple until steps fail independently.

### Why NOT Just Chain Lambdas?

So many reasons not to do this. In simple terms, think of this as making a house of cards. Can break if one card falls. Chaining Lambdas:

* Hides state
* Complicates retries
* Makes debugging painful

With Step Functions, you get benefits such as:

* Each step is explicit
* Failures are observable
* Retries are declarative

### Designing the State Machine

We need to understand these concepts while designing a state machine. Always remember each state:

* Does one thing
* Has clear input/output
* Is independently testable

### Retry and Catch: The Killer Feature

Let's talk about Retry mechanism. Instead of try/catch in code:

\`\`\`plaintext
"Retry": [{
  "ErrorEquals": ["States.ALL"],
  "IntervalSeconds": 2,
  "MaxAttempts": 3,
  "BackoffRate": 2
}]
\`\`\`

This approach:

* Reduces code complexity
* Makes behavior predictable
* Avoids duplicate execution

### Standard vs Express: Choosing Correctly

Let's talk about two types of step-function workflows.

**Standard Workflows**

* Long-running and Auditable workflows, as they show history or logs and visual debugging.
* Higher cost per execution

**Express Workflows**

* High-volume, high-event-rate applications, like streaming data processing and IoT data ingestion.
* They are Short-lived.

I choose based on **business requirements**, not habit.

### Why Step Functions Shine

Executions are like flowchart visualization. If you can see history and see what is happening, then what more do you need? The execution history shows:

* Input per state
* Output per state
* Failure reason
* Retry attempts

This alone saved hours of debugging. You see, learn, fix, and improve faster.

### Payload Management (A Hard-Learned Lesson)

You won't realize this till you fail. Step Functions pass JSON between states.

Mistakes that we commonly make:

* Passing large objects. There are size limit for payload, consider that.

Solution that everyone tells:

* Store data in S3. Most people on the internet recommend this, and so do I.
* Pass references instead.

This keeps workflows fast and cheap. One large payload won't break your flow.

### Cost Considerations

There are several factors for your cost. Some of these factors are:

* Number of state transitions. Even though there are some free tier limit you must consider this.
* Workflow type.

Even then, cost is predictable, unlike hidden retry storms in code.

### Anti-Patterns to Avoid

Let's talk about some design patterns to avoid while using step functions.

* One Lambda is doing everything. Do not make it one man army.
* Over-nested state machines. We are supposed to keep our architecture separate and simple.
* Using Step Functions for simple tasks.
* Passing secrets in the state input

### When Step Functions Are Overkill

Not every good solution is the best solution for you. We need to learn when and when not to use step functions. Size matters or not, I don't know, but the size of your skills and, more importantly size of your budget do matter. Do not use Step Functions if:

* Single Lambda is enough. No need to do overkill.
* No retries needed. Remember this every time.
* Workflow is purely synchronous. If no asynchronous, then try to manage accordingly.

### At last

Step Functions didn't reduce complexity; they **made complexity visible**. That visibility is what allowed me to build reliable serverless workflows without losing control. If your Lambda code looks like a flowchart, it probably belongs in a state machine. You should probably look into [step functions workflow studio](https://aws.amazon.com/blogs/aws/new-aws-step-functions-workflow-studio-a-low-code-visual-tool-for-building-state-machines/) if you want to make your work easy.`
  }
]

const workshops = [
  {
    title: 'Introduction to Git and GitHub',
    date: 'March 18, 2023',
    duration: '1 Day Workshop',
    description: 'Hands-on workshop covering Git version control and GitHub collaboration',
    participants: '50+ students',
    organization: null,
    type: 'workshop',
    link: 'https://www.facebook.com/share/p/17tTX6S6Bk/',
  },
  {
    title: 'AWS Cloud-Computing Workshop (Phase-1)',
    date: 'December 3, 2023',
    duration: 'Workshop',
    description: 'Introduction to AWS cloud computing fundamentals',
    participants: '50+ students',
    organization: null,
    type: 'workshop',
    link: 'https://www.facebook.com/share/p/1TcbuiUcqR/',
  },
  {
    title: '7 Days Workshop on React.js',
    date: 'April 7, 2024',
    duration: '7 Days Workshop',
    description: 'Comprehensive React.js workshop covering fundamentals to advanced concepts',
    participants: null,
    organization: 'Mount Annapurna Campus, MacItHub',
    type: 'workshop',
    link: 'https://www.facebook.com/share/p/1DqxJZ7m29/',
  },
  {
    title: 'Cloud Computing with AWS',
    date: 'June 16, 2024',
    duration: '45 Days Workshop',
    description: 'Extensive cloud computing course with AWS services',
    participants: '100+ students',
    organization: 'CSIT Association of Nepal, Pokhara',
    type: 'workshop',
    link: 'https://www.facebook.com/share/p/1AAWnjTvwG/',
  },
  {
    title: 'Introduction to Cloud and AWS',
    date: 'August 8, 2025',
    duration: '15 Days Workshop',
    description: 'Comprehensive introduction to cloud computing concepts and AWS services',
    participants: null,
    organization: 'Mount Annapurna Campus Pokhara',
    type: 'workshop',
    link: 'https://www.facebook.com/share/p/1F2BPU41WJ/',
  },
  {
    title: 'Host Your First Web Application on AWS: From Zero to Scalable',
    date: 'October 15, 2025',
    duration: 'Workshop',
    description: 'Hands-on workshop on deploying scalable web applications on AWS',
    participants: '60+ students',
    organization: 'Bingo Academy',
    type: 'workshop',
    link: 'https://www.facebook.com/share/p/187hWDZfQG/',
  },
  {
    title: 'Best of Both Worlds: Headless WordPress with Next.js',
    date: 'November 8, 2025',
    duration: 'Speaker Session',
    description: 'Speaker session on integrating headless WordPress with Next.js for modern web development',
    participants: null,
    organization: 'WordCamp Bharatpur',
    type: 'speaker',
    link: 'https://www.facebook.com/share/r/184y8dUCqr/',
  },
]

const commercialProjects = [
  {
    name: 'Yellowcafe - Brand',
    description:
      'Yellow Cafe offers a unique coffee experience in Ireland, blending artisanal brews, fresh-baked treats, and a warm, inviting atmosphere for every occasion.',
    stack: ['Branding', 'Headless CMS', 'Next.js'],
    livePreview: '#', 
    imageFallback: 'yellowcafe',
  },
  {
    name: 'Raptor Motorcycle Nepal',
    description:
      'Founded in 2017, Raptor Motorcycle is a trusted brand fostering offroad culture with durable, cost-effective, and unique products for riders in Nepal.',
    stack: ['E-Commerce', 'Web App', 'Design'],
    livePreview: '#',
    imageFallback: 'raptor',
  },
  {
    name: 'Exotic Food Services - B2B',
    description:
      'A B2B grocery supplier in Belgium, evolving from a local supermarket into a global hub for international products, including Turkish and many others.',
    stack: ['B2B Solutions', 'Global Shipping', 'Platform'],
    livePreview: '#',
    imageFallback: 'exotic',
  },
  {
    name: 'Rackly',
    description: 'Rackly is a complete digital rack for businesses to list, manage, and sell their products and services. With integrated inventory tracking, order management, and WhatsApp order support, Rackly makes running your business effortless. You also get a customizable website with custom domain support to strengthen your online presence.',
    stack: ['Next.js', 'PostgreSQL', 'Stripe', 'AWS'],
    livePreview: 'https://rackly.app',
    imageFallback: 'rackly',
  },
  {
    name: 'Domainly',
    description: 'Domainly provides a powerful API-driven infrastructure for adding custom domains and subdomains to your SaaS product. With built-in DNS management and SSL provisioning, Domainly ensures your users can connect their domains seamlessly. Whether you\'re building a SaaS platform, marketplace, or portal, Domainly simplifies domain mapping, enhances brand credibility, and scales with your business.',
    stack: ['Next.js', 'DNS', 'API', 'AWS'],
    livePreview: 'https://domainly.dev',
    imageFallback: 'domainly',
  },
]

export { header, about, projects, commercialProjects, skills, contact, certifications, experience, education, volunteering, blogs, workshops }